import {GenericLinkedResource} from '@catcore/types/base';

export interface Registration {
    id: number;
    name: string;
}

export interface Briefing {
    id: number;
    name: string;
    filename: string;
    folder: string;
    baseline: boolean;
    smoking: boolean;
    bunkbed: boolean;
    _links: {
        registration?: Registration;
        self: {
            href: string;
        };
    };
}

export interface AircraftRegistration {
    id: number;
    name: string;
    _links: {
        self: {
            href: string;
        };
    };
}

export interface UserdataFileType {
    id: number;
    name: string;
}

export interface UserdataFileVersion {
    id: number;
    name: string;
    _links: {
        self: {
            href: string;
        };
    };
}

export interface UserdataFile {
    id: number;
    filename: string;
    path: string;
    baseline: boolean;
    bunkbed: boolean;
    smoking: boolean;
    always_part_of_package: boolean;
    target_package_filename: string;
    target_package_path: string;
    _links: {
        self: any;
        type?: GenericLinkedResource;
        registration?: GenericLinkedResource;
        version?: GenericLinkedResource;
    };
}

export class UserdataImages {
    logo: UserdataFile;
    farewell: UserdataFile;
    welcome: UserdataFile;
}

export interface BriefingSelection {
    briefing: UserdataFile;
    selected: boolean;
}

export interface UserdataConfig {
    smoking: boolean;
    bunkbed: boolean;
    extended: boolean;
    logo: string;
    logo_file_name: string;
    logo_file: any;
    welcome: string;
    welcome_file_name: string;
    welcome_file: any;
    farewell: string;
    farewell_file_name: string;
    farewell_file: any;
    version: number;
    id: number;
    formatted_version: string;
    zip_existing: boolean;
    package_existing: boolean;
    _links: {
        self: any;
        project?: GenericLinkedResource;
        registration?: GenericLinkedResource;
        file_version?: GenericLinkedResource;
    };
}

export enum UploadTypes { None = 'NONE', Default = 'DEFAULT', Upload = 'UPLOAD'}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/userdata-generation/types.ts